export default "__VITE_ASSET__E0CL8mBJ__"